export const DATA_TABINDEX = 'xvx-tabindex';
export const DATA_ELEMENT_ID = 'xvx-element-id';
export const DATA_TYPE = 'type';
export const DATA_VISIBILITY_CONFIG = 'config';
export const DATA_HISTORY_ENABLED = 'xvx-history-enabled';
export const DATA_EXIT_ENABLED = 'xvx-exit-enabled';
export const DATA_ORIGIN_URL = 'xvx-origin-url';
export const DATA_USE_NATIVE = 'xvx-use-native';
export const DATA_ICON = 'icon';
export const DATA_LABEL = 'label';
export const DATA_ICON_IN_OPTIONS = 'icon-in-options';

export default {
  TABINDEX: DATA_TABINDEX,
  HISTORY_ENABLED: DATA_HISTORY_ENABLED,
  EXIT_ENABLED: DATA_EXIT_ENABLED,
  ORIGIN_URL: DATA_ORIGIN_URL,
  USE_NATIVE: DATA_USE_NATIVE,
};
